import { useIsFirstRun } from '@cian/valuation-utils-component';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setPushNotificationsAllowed } from '../../../actions/page';
import { selectPushNotificationEnabled } from '../../../selectors/page';
import { localStorageService } from '../../../utils/localStorageService';

export const PUSH_ALLOWED_LS_KEY = 'push_notifications_allowed';

export const useInitPushAllowed = () => {
  const isPushNotificationsAllowed = useSelector(selectPushNotificationEnabled);
  const dispatch = useDispatch();
  const isFirstRun = useIsFirstRun();

  /**
   * Инициализация. Синхронизируем redux и LS в зав-ти от наличия того или иного.
   * Если страница открывается с query параметром, то он в приоритете записывается в LS и redux
   * Если нет query параметра, но есть LS, то в стор добавляется значение из LS
   * */
  useEffect(() => {
    const pushAllowedLsService = localStorageService<boolean>(PUSH_ALLOWED_LS_KEY);
    const pushNotificationsAllowed = pushAllowedLsService.get();

    /** Если в сторе уже что-то есть, то синхронизируем redux->LS */
    if (isPushNotificationsAllowed != null) {
      pushAllowedLsService.set(isPushNotificationsAllowed);
    } else if (pushNotificationsAllowed != null) {
      /** Иначе, если в LS уже что-то есть, синхронизируем LS->redux */
      dispatch(setPushNotificationsAllowed(pushNotificationsAllowed));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Когда меняется значение в сторе, оно обновляет значение в LS
   * Первый заход пропускается
   * */
  useEffect(() => {
    if (isFirstRun) {
      return;
    }

    const pushAllowedLsService = localStorageService<boolean>(PUSH_ALLOWED_LS_KEY);

    if (isPushNotificationsAllowed != null) {
      pushAllowedLsService.set(isPushNotificationsAllowed);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPushNotificationsAllowed]);
};
